/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';

import p from 'polyglot/polyglot';

import styles from './history.scss';

/**
 * This is the History component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class History extends PureComponent {
  /**
   * Render History.
   *
   * @return {Object}
   */
  render() {
    return (
      <article className={styles.wrapper}>
        <div className={styles.row}>
          <header className={styles.content}>
            <h1>{p.t('payments.history.no_result')}</h1>
          </header>
        </div>
      </article>
    );
  }
}
